import Filter from "./features/Filter";
import {useState} from "react";
import {OcSearchParamType} from "./interface";
import {ocListMapInit, ocSearchParamType} from "./state";
import {useReadOverseas} from "./hooks/useReadOverseas";
import TabNav from "./features/TabNav";

export default function OcList() {

    const [searchParam, setSearchParam] = useState<OcSearchParamType>(ocSearchParamType)
    const [selectedItem, setSelectedItem] = useState<number[]>([])

    const {data: oc} = useReadOverseas({param: searchParam});

    return <>
        <Filter searchParam={searchParam}
                setSearchParam={setSearchParam}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}/>

        <TabNav oc={oc ?? ocListMapInit}
                searchParam={searchParam}
                setSearchParam={setSearchParam}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}/>
    </>
}